<template>
  <div class="module-wrapper market-wrapper" @touchend="handleTouchend" >
    <span id="market-chart-tab" class="market-wrapper-nav-tag"></span>
    <transition name="slide-fade-NGuide">
    <div class="userMGuide"
    v-if="hdmmdtipshow"
    :style="`left:${hdmmLeft}px;top:${hdmmTop}px`">
      <div class="userMGuideTri"
      :style="'left:90px'" ></div>
      <div class="userMGuideCont" >
        <span
          :class="[isIoS ? 'userMGuideText' : 'userMGuideText2']">后端基金的买卖点也可以查看啦~</span>
      </div>
      <div class="userMGuideSep" >
      </div>
    </div>
    </transition>
    <!-- tab按钮组 -->
    <div v-if="typeName" class="tabs-wrapper">
      <div v-for="(chart, index) in
        config.type[typeName].chartList"
        :key="index"
        @click="updateChart('typeIndex', index, true)"
        :class="[is5s?'tab5s':'tab', typeIndex === index ? 'tab-selected' : '']"
      >
        <div class="tabs-item-text">
          {{ chart.name.replace('万份', `${ hbTitleUnit }份`) }}
        </div>
      </div>
    </div>

    <div v-if="!typeName" class="chart-wrap-loading first-loading"></div>
    <!-- 图表组 -->

    <div v-if="typeName" class="chart-wrap" id="market-chart-wrap">

      <!-- 放大按钮 -->
      <div v-if="!isLoading && !isNoData && !webload"
      class="scale-btn" @click="jumpToBigChart"></div>

      <div v-for="(chart, index) in config.type[typeName].chartList"
        :key="index"
        :class="['chart-item', typeIndex==index ? 'chart-item-avtive' : '']"
        :style="{height:`${isNoData?'298px':'auto'}`}"
      >
        <!-- 加载中 -->
        <div v-if="isLoading" class="chart-wrap-loading">
          <div class="load-container load2">
            <div class="loader">
              <div class="loader-circle"></div>
            </div>
          </div>
        </div>
        <!-- 估值关闭 -->
        <div v-else-if="!isOpenGz && chart.name==='净值估算'"
        class="chart-wrap-no-data-closegz">
          <div class="close-gz-title">
            <img src="@/assets/efgz.png" alt="" class="close-gz-title-image">
            <div class="close-gz-title-text">
              开启净值估算须知
            </div>
          </div>
          <div class="close-gz-content-text">
            净值估算数据按照基金历史披露持仓和指数走势估算，不构成投资建议，仅供参考，实际以基金公司披露净值为准。
          </div>
          <div class="close-gz-op-btn">
            <div class="close-gz-op-btn-txt" @click="opengztip">
              确认开启
            </div>
          </div>
        </div>
        <!-- 加载(基金基本信息)失败 -->
        <div
          v-else-if="isShowNetErrorTips"
          class="chart-wrap-no-data"
          @click="reload"
        >网络不给力，请点击重试</div>
        <!-- 加载(基金基本信息)失败 -->
        <div v-else-if="isLoadError" class="chart-wrap-no-data">加载失败</div>
        <!-- 暂无数据 -->
        <div v-else-if="isNoData && chart.name==='净值估算' && isQDII"
        class="chart-wrap-no-data-qdii-closegz">
        <div class="close-gz-content-text">当前产品为QDII基金，投资于境外市场，暂无净值估算数据。</div>
        </div>
        <!-- 暂无数据 -->
        <div v-else-if="isNoData" class="chart-wrap-no-data">暂无数据</div>

        <!-- 图例-累计收益 -->
        <div v-if="chart.name === '累计收益' && isShowyj"
          :class="['legend', 'flex', isSliding ? 'actived': '']"
        >
          <div v-for="(label, index) in
            [
              isSliding ? '本基金' : config.timeList[timeIndex].name,
              '同类平均',
              indexName,
              '业绩比较基准',
            ]"
            :key="`${label}${config.timeList[timeIndex].name}${index}`"
            class="legend-item"
             @click="showMoreIndex(index)"
          >
            <div class="legend-flex-box">
              <span class="legend-item-icon" :style="{ background: config.colors[index] }"></span>
              <span :class="['legend-item-name', `legend-rev-${index}`]">
                <span v-if="label === '近1月' && ESTABYEAR == 0 && ESTABDAY<30">
                  成立来(不满1月)
                </span>
                <span v-else-if="label === '近3月' && ESTABYEAR == 0 && ESTABDAY<30*3">
                  成立来(不满3月)
                </span>
                <span v-else-if="label === '近6月' && ESTABYEAR == 0 && ESTABDAY<30*6">
                  成立来(不满6月)
                </span>
                <span v-else-if="label === '近1年' && ESTABYEAR == 0">
                  成立来(不满1年)
                </span>
                <span v-else-if="label === '近3年' && ESTABYEAR < 3 ">成立来(不满3年)</span>
                <span v-else-if="label === '近5年' && ESTABYEAR < 5 ">成立来(不满5年)</span>
                <span v-else-if="label === '今年来' && isThisYearCreated(baseInfo.ESTABDATE) ">
                  {{ `${'成立来'}(${baseInfo.ESTABDATE.substring(5)})`  }}
                </span>
                <span v-else>{{ label  }}</span>
                <span>:</span>
              </span>
              <span :class="[
                'legend-item-value',
                getRiseClassName( total_revenue_legend[isSliding?'active':'last'][index] )
              ]">
                {{
                  numeral(total_revenue_legend[isSliding?'active':'last'][index])
                    .format('0.00%', Math.trunc)
                }}
              </span>
              <img class="warn-tip-gray"
                src='@/assets/warn-tip-gray.png' v-if="index===3 && !isSliding" />
                <img class="warn-tip-gray"
                src='@/assets/warn-tip-gray.png' v-if="index===1 && !isSliding" />
              <div v-if="index===2 && !isSliding" class="arrow-qt" id="ljsytipview"></div>
            </div>
          </div>
        </div>

        <div v-if="chart.name === '累计收益' && !isShowyj"
          :class="['legend', 'flex', isSliding ? 'actived': '']"
        >
          <div v-for="(label, index) in
            [
              isSliding ? '本基金' : config.timeList[timeIndex].name,
              '同类平均',
              indexName,
            ]"
            :key="`${label}${config.timeList[timeIndex].name}${index}`"
            class="legend-item"
            @click="showMoreIndex(index)"
          >
            <div class="legend-flex-box">
              <span class="legend-item-icon" :style="{ background: config.colors[index] }"></span>
              <span :class="['legend-item-name', `legend-rev-${index}`]">
                <span v-if="label === '近1月' && ESTABYEAR == 0 && ESTABDAY<30">
                  成立来(不满1月)
                </span>
                <span v-else-if="label === '近3月' && ESTABYEAR == 0 && ESTABDAY<30*3">
                  成立来(不满3月)
                </span>
                <span v-else-if="label === '近6月' && ESTABYEAR == 0 && ESTABDAY<30*6">
                  成立来(不满6月)
                </span>
                <span v-else-if="label === '近1年' && ESTABYEAR == 0">
                  成立来(不满1年)
                </span>
                <span v-else-if="label === '近3年' && ESTABYEAR < 3 ">成立来(不满3年)</span>
                <span v-else-if="label === '近5年' && ESTABYEAR < 5 ">成立来(不满5年)</span>
                <span v-else-if="label === '今年来' && ESTABYEAR < 1 ">
                  {{ `${'成立来'}(${baseInfo.ESTABDATE.substring(2)}成立)`  }}
                </span>
                <span v-else>{{ label  }}</span>
                <span>:</span>
              </span>
              <span :class="[
                'legend-item-value',
                getRiseClassName( total_revenue_legend[isSliding?'active':'last'][index] )
              ]">
                {{
                  numeral(total_revenue_legend[isSliding?'active':'last'][index])
                    .format('0.00%', Math.trunc)
                }}
              </span>
              <img class="warn-tip-gray"
                src='@/assets/warn-tip-gray.png' v-if="index===3 || index===1" />
              <div v-if="index===2 && !isSliding" class="arrow-qt" id="ljsytipview"></div>
            </div>
          </div>
        </div>

        <!-- 图例-单位净值/净值 -->
        <div v-if="chart.name === '单位净值' || chart.name === '净值'"
          :class="['legend', isSliding ? 'actived': '']"
        >
          <div class="legend-item" style="width: 40%">
            {{ unit_net_legend[isSliding?'active':'last'][0] }}</div>
          <div class="legend-item" style="width: 60%">
            <span class="legend-item-title">单位净值:</span>
            <span class="legend-item-data">
              {{
                numeral(unit_net_legend[isSliding?'active':'last'][1])
                  .format('0.0000', Math.trunc)
              }}
            </span>
          </div>
          <div class="legend-item" style="width: 40%">
            <span class="legend-item-title">日涨幅:</span>
            <span :class="[
              'legend-item-data',
              getRiseClassName( unit_net_legend[isSliding?'active':'last'][2] )
            ]">
              {{
                numeral(unit_net_legend[isSliding?'active':'last'][2])
                  .format('0.00%', Math.round)
              }}
            </span>
          </div>
          <div v-if="unitPrice" class="legend-item"  style="width: 60%">
            <span class="legend-item-title"
            @click="alertCostAlertTips">{{getUnitPriceTitle()}}:</span>
            <span class="legend-item-data"
            @click="alertCostAlertTips">
              {{
                numeral(unitPrice).format('0.0000', Math.trunc)
              }}
            </span>
            <img v-if="holdUnitPriceLsit.length > 1"
            class="warn-jztip-gray" src='./images/qt.png' />
            <img @click="alertCostTips" class="warn-jztip-gray" src='@/assets/warn-tip-gray.png' />
          </div>
        </div>

        <!-- 图例-累计净值 -->
        <div v-if="chart.name === '累计净值'" :class="['legend', isSliding ? 'actived': '']" >
          <div class="legend-item">{{ total_net_legend[isSliding?'active':'last'][0] }}</div>
          <div class="legend-item">
            <span class="legend-item-title">累计净值:</span>
            <span class="legend-item-data">
              {{
                numeral(total_net_legend[isSliding?'active':'last'][1])
                  .format('0.0000', Math.trunc)
              }}
            </span>
          </div>
        </div>

        <!-- 图例-净值估算 -->
        <div v-if="chart.name === '净值估算'" :class="['legend', isSliding ? 'actived': ''
        ,getgzGsClass(chart.name,isOpenGz)]" >
          <div class="legend-item" >
            {{ tools.noData(nowDate) }} {{ net_worth_legend[isSliding?'active':'last'][0] }}
          </div>
          <div class="legend-item" v-if="hadDWJZ">
            <span class="legend-item-title">净值估算:</span>
            <span :class="[
              'legend-item-data',
              getRiseClassName( net_worth_legend[isSliding?'active':'last'][2] )
            ]">
              {{
                numeral(net_worth_legend[isSliding?'active':'last'][1])
                  .format('0.0000', Math.trunc)
              }}
            </span>
          </div>
          <div class="legend-item" >
            <span class="legend-item-title">估算涨幅:</span>
            <span :class="[
              'legend-item-data',
              getRiseClassName( net_worth_legend[isSliding?'active':'last'][2] )
            ]">
              {{
                numeral(net_worth_legend[isSliding?'active':'last'][2])
                  .format('0.00%', Math.round)
              }}
              <!-- {{ net_worth_legend[isSliding?'active':'last'][2] }} -->
            </span>
          </div>
          <div class="legend-item">
            <span class="legend-item-title">估算偏差:</span>
            <span class="legend-item-data">
              {{
                numeral(ESTDIFF).format('0.00%', Math.round)
              }}
            </span>
            <img @click="throttlealertGSPCTips"
            class="warn-tip-gray" src='@/assets/warn-tip-gray.png' />
          </div>
        </div>

        <!-- 图例-万份收益 -->
        <div v-if="chart.name === '万元收益'" :class="['legend', isSliding ? 'actived': '']" >
          <div class="legend-item">{{ wan_profit_legend[isSliding?'active':'last'][0] }}</div>
          <div class="legend-item">
            <span class="legend-item-title">万元收益:</span>
            <span class="legend-item-data">
              {{
                numeral(wan_profit_legend[isSliding?'active':'last'][1])
                  .format('0.0000', Math.trunc)
              }}
            </span>
          </div>
          <div class="legend-item">
            <span class="legend-item-title">7日年化:</span>
            <span :class="[
              'legend-item-data',
              getRiseClassName( wan_profit_legend[isSliding?'active':'last'][2] )
            ]">
              {{
                numeral(wan_profit_legend[isSliding?'active':'last'][2])
                  .format('0.0000%', Math.trunc)
              }}
            </span>
          </div>
        </div>

        <!-- 图例-7日年化 -->
        <div v-if="chart.name === '7日年化'"
          :class="['legend', isSliding ? 'actived': '']"
        >
          <div v-for="(label, index) in ['7日年化', '一年定存']"
            :key="`${label}${config.timeList[timeIndex].name}${index}`"
            class="legend-item"
          >
            <div class="legend-flex-box">
              <span class="legend-item-icon" :style="{
                background: ['rgba(255,68,0,1)', 'rgba(0,138,255,1)'][index]
              }"></span>
              <span class="legend-item-name">{{ label }}:</span>
              <span :class="[
                'legend-item-value',
                getRiseClassName( seven_profit_legend[isSliding?'active':'last'][index] )
              ]">
                {{
                  [
                    numeral(seven_profit_legend[isSliding?'active':'last'][index])
                      .format('0.0000%', Math.trunc),
                    numeral(seven_profit_legend[isSliding?'active':'last'][index])
                      .format('0.00%', Math.trunc),
                  ][index]
                }}
              </span>
            </div>
          </div>
        </div>

        <!-- 图例-金价走势 -->
        <div v-if="chart.name === '金价走势'" :class="['legend', isSliding ? 'actived': '']"
        >
          <div class="legend-item">
            {{ gold_legend[isSliding?'active':'last'][0] }}
          </div>
          <div class="legend-item">
            <span class="legend-item-title">国内AU9999:</span>
            <span class="legend-item-data">
              {{ gold_legend[isSliding?'active':'last'][1] }}元/克
            </span>
          </div>
          <div class="legend-item">
            <span class="legend-item-title">日涨幅:</span>
            <span :class="[
              'legend-item-data',
              getRiseClassName( gold_legend[isSliding?'active':'last'][2] )
            ]">
              {{
                numeral(gold_legend[isSliding?'active':'last'][2])
                      .format('0.00', Math.trunc)
              }}%
            </span>
          </div>
        </div>

        <div :class="['chart-canvas-wrap',getgzGsClass(chart.name,isOpenGz)]" >
          <canvas v-if="!/分|K/.test(chart.name)" class="chart-canvas" :id="chart.id" />
          <div v-else class="on-line-chart-frame-wrap" ref="frameWrap" :id="chart.id">
            <!-- <iframe class="on-line-chart-frame" :src="onLineChartUrl"
              :style="`width:${innerWidth-30}px`"
            ></iframe> -->
          </div>
        </div>

        <!-- 数据准确度提示 -->
        <div v-if="chart.name === '净值估算'"
        :class="['net-worth-tips',getgzGsClass(chart.name,isOpenGz)]">
          净值估算数据按照基金历史披露持仓和指数走势估算，不构成投资建议，仅供参考，实际以基金公司披露净值为准。
        </div>
      </div>
    </div>

    <!-- 时间区间选择 -->
    <div v-if="typeName && toggleShowTimeTab()" class="time-interval-wrap">
      <div v-for="(time, index) of config.timeList.slice(0,this.showTimeBtnNum)"
        :key="index"
        :class="['time-btn', timeIndex === index ? 'time-btn-selected' : '']"
        @click="updateChart('timeIndex', index, true)"
      >
        <div class="time-btn-text">{{ time.name }}</div>
      </div>

      <div :class="['time-btn', timeIndex >= 4 ? 'time-btn-selected' : '']">
        <div class="time-btn-text" @click="showMoreTime">
          {{ timeIndex >= 4 ? config.timeList[timeIndex].name : '更多' }}
        </div><img class="warn-tip-qt" src='@/assets/qt.png' style="width: 12px;
    height: 12px;" />
      </div>

    </div>
  </div>
</template>

<script>
import FundTypeSearch from '@/utils/FundTypeSearch';
import StoreManger from '@/utils/FundHQJHManger';
import { numeral } from '@fund/basic-lib';
import tools from '@fund/data';
import { throttle } from '@fund/basic-lib/dist/lib/function';
import { setStorage, getStorageSync } from '@fund/storage';
import {
  gotoJumpBigChartView,
  gotoBigChartView,
  openHorizontalScroll,
  setCommonStorageSync,
  detailPushPage,
} from '@/utils/nativeBridge';

import JS from '@/base/JSTool';
import NativeMsg from '@/base/NativeMsg';

// import { getApiHostWithoutEnv } from '@fund/api-host';
import Util from '@/base/Util';
// eslint-disable-next-line import/extensions
import F2 from './libs/f2.js';
// import F2 from '@antv/f2';
import { market as config } from './config';
import Model from './model';
import drawTotalRevenue from './draw/market_total_revenue';
import drawUnitNet from './draw/market_unit_net';
import drawTotalNet from './draw/market_total_net';
import drawMarket10000SharesProfit from './draw/market_10000_shares_profit';
import drawMarket7daysProfit from './draw/market_7_days_profit';
import drawMarketGold from './draw/market_gold';
// import netWorth from './draw/market_net_worth';
import gsWorth from './draw/market_gs';

// 格式化'%'时不自动除100
numeral.options.scalePercentBy100 = false;

// let dt = 0;
// const startTag = () => {
//   dt = new Date().getTime();
// };
// const endTag = (name) => {
//   console.warn(name, '耗时', new Date().getTime() - dt, 'ms');
//   startTag();
// };
export default {

  name: 'FundChartMarket',

  props: ['baseType'],

  components: {
  },

  data() {
    return {
      // 是否首次加载
      isFirstLoad: true,
      // render回调执行后
      rendered: false,
      // 显示时间个数
      showTimeBtnNum: 4,
      // 数据类型索引
      typeIndex: 0,
      // 时间类型索引
      timeIndex: 3,
      // 当前指数
      indexCode: '',
      // 当前指数名称
      indexName: '',
      // 是否正在加载
      isLoading: true,
      // 是否无数据
      isNoData: false,
      // 加载失败
      isLoadError: true,
      // 估值格式化后的数据
      netWorthFormatData: null,

      // 估值净值
      hadDWJZ: true,
      // 时间区间缓存字段名
      timeIndexCacheId: 'fund-detail-market-chart-user-select-time-index',

      // 嵌入式图表链接
      onLineChartUrl: '',
      config,
      numeral,
      tools,
      // 屏幕宽度
      innerWidth: 0,
      // 货币基金收益单份数
      hbTitleUnit: '万',

      // 设置展示TAB类型
      typeName: '',

      // 基金指定指数
      targetIndex: null,

      // 成立时长
      ESTABTimeLength: '',

      // 当前日期
      nowDate: '',

      // 成立年份
      ESTABYEAR: 0,

      // 成立天
      ESTABDAY: 0,

      // 买卖点数据
      buyAndSellPointData: {
        BuyPoints: [],
        SellPoints: [],
        qdBuyPoints: [],
        qdSellPoints: [],
        hdBuyPoints: [],
        hdSellPoints: [],
      },

      // 累计收益图例数据
      // [本基金, 同类基金, 指数]
      total_revenue_legend: {
        last: ['', '', '', ''],
        active: ['', '', '', ''],
      },

      // 单位净值图例数据
      // [日期, 单位净值, 涨幅]
      unit_net_legend: {
        last: ['', '', ''],
        active: ['', '', ''],
      },

      // 累计净值图例数据
      // [日期, 累计净值]
      total_net_legend: {
        last: ['', ''],
        active: ['', ''],
      },

      // 净值估算
      // [日期, 估值, 涨幅]
      net_worth_legend: {
        last: ['', '', ''],
        active: ['', '', ''],
      },

      // 万份收益
      // [日期, 万份收益, 7日年化]
      wan_profit_legend: {
        last: ['', '', ''],
        active: ['', '', ''],
      },

      // 累计收益图例数据
      // [7日年化, 一年期定存]
      seven_profit_legend: {
        last: ['', ''],
        active: ['', ''],
      },

      // 金价走势图例数据
      // [日期, 单价, 日涨幅]
      gold_legend: {
        last: ['', '', ''],
        active: ['', '', ''],
      },

      // 是否正在滑动
      isSliding: false,

      // 接口公共参数
      publicParams: {},

      // 基本信息
      baseInfo: {},

      // 摊薄成本单价
      unitPrice: null,

      // 摊薄成本单价是否在折线范围内
      showUnitPrice: false,

      // 是否已经加载过成本线和买卖点
      hasLoadHoidAndPointData: false,

      // 是否正在重绘
      isReDrawing: false,

      // 已加载完用户的购买信息
      hadLoadUserBuyInfo: false,

      // 是否已渲染用户的买卖点
      hadRenderUserPoint: false,

      // 首屏图表已显示
      hadShowFirstScreen: false,

      // 关键点日期组
      DATES: '',

      // 估值开启
      isOpenGz: false,

      // QDII
      isQDII: false,

      // 是否展示网络不给力提示
      isShowNetErrorTips: false,

      // 显示业绩
      isShowyj: true,
      // web
      webload: false,
      gotobigBack: false,
      is5s: false,
      holdUnitPriceLsit: [],
      holdUnitPriceSelectIndex: 0,
      // 估值偏差
      ESTDIFF: null,
      // 指引
      ljsyzsLeft: 90,
      ljsyzsTop: 115,
      hdmmLeft: 80,
      hdmmTop: 200,
      ljsyzsShow: false,
      isIoS: false,
      hdmmdtipshow: false,
      hdcaUid: '',
    };
  },

  created() {
    // #if EXECUTION_ENV == 'web'
    this.webload = true;
    // #endif
    // 估值开启
    this.setGZOpenTip();
    // this.timeIndex = this.getSelectTimeIndex();
    this.setTabType();

    setInterval(() => {
      if (this.onLineChartUrl) {
        const clearUrl = this.onLineChartUrl.replace(/#.?$/, '');
        this.onLineChartUrl = `${clearUrl}#${new Date().getTime()}`;
        this.createIframe(this.onLineChartUrl);
      }
    }, 7 * 60 * 1000);

    setInterval(() => {
      const data = this.netWorthFormatData;
      // 如果净值估算走势数据不完整，自刷新
      if (
        data
        && this.typeIndex === 3
        && data[data.length - 1].rise === null
        && !this.isReDrawing
      ) {
        this.isReDrawing = true;
        this.updateChart();
      }
    }, 60 * 1000);
    if (window.innerWidth <= 320) {
      this.is5s = true;
    }
    NativeMsg.reg('onPageShow', () => {
      this.onPageShow();
    });
    NativeMsg.reg('appear', () => {
      this.onPageShow();
    });
    NativeMsg.reg('reloadUserProfit', () => {
      this.configureHoldData();
    });
    // #if EXECUTION_ENV === 'fund'
    // eslint-disable-next-line no-undef
    const systemInfo = fund.getSystemInfoSync();
    console.log(JSON.stringify(systemInfo));
    if (systemInfo) {
      if (systemInfo.system) {
        if (systemInfo.system.indexOf) {
          if (systemInfo.system.indexOf('iOS') !== -1) {
            this.isIoS = true;
          }
        }
      }
    }
    // #endif

    this.hdmmLeft = (window.innerWidth - 220) / 2;
  },

  mounted() {
    // this.renderTest();

  },

  methods: {
    getUnitPriceTitle() {
      if (this.holdUnitPriceLsit.length === 1) {
        if (this.holdUnitPriceLsit[this.holdUnitPriceSelectIndex].chartT === '前端') {
          return '摊薄成本单价';
        }
        return `摊薄成本(${this.holdUnitPriceLsit[this.holdUnitPriceSelectIndex].chartT})`;
      }
      if (this.holdUnitPriceLsit.length > 0) {
        return `摊薄成本(${this.holdUnitPriceLsit[this.holdUnitPriceSelectIndex].chartT})`;
      }
      return '摊薄成本单价';
    },
    async configureHoldData() {
      const { fundCode } = this.$store.state.native.fund;
      this.FCODE = fundCode || '000001';
      const baseInfo = StoreManger.getFundJJXQ();
      const hdcode = baseInfo.BACKCODE;
      const qdcode = baseInfo.FCODE;
      const data = StoreManger.GetFundsProductProfit();
      const aletlist = [];
      let allBuyList = [];
      let allSaleList = [];
      let hdBuyList = [];
      let hdSaleList = [];
      let qdBuyList = [];
      let qdSaleList = [];
      if (data) {
        if (data.Data) {
          data.Data.forEach((element) => {
            if (element.FundCode === qdcode) {
              allBuyList = JSON.parse(JSON.stringify(element.BuyPoints));
              qdBuyList = JSON.parse(JSON.stringify(element.BuyPoints));
              allSaleList = JSON.parse(JSON.stringify(element.SellPoints));
              qdSaleList = JSON.parse(JSON.stringify(element.SellPoints));
              if (element.TotalWithoutCashBagProfitInfo) {
                aletlist.push({
                  title: '摊薄成本单价(前端)',
                  chartT: '前端',
                  UnitPrice: element.TotalWithoutCashBagProfitInfo.UnitPrice,
                });
              }
            }
            if (element.FundCode === hdcode) {
              hdBuyList = element.BuyPoints;
              hdSaleList = element.SellPoints;
              hdBuyList.forEach((bitem) => {
                allBuyList.push(`${bitem}`);
              });
              hdSaleList.forEach((bitem) => {
                allSaleList.push(`${bitem}`);
              });
              if (element.TotalWithoutCashBagProfitInfo) {
                aletlist.push({
                  title: '摊薄成本单价(后端)',
                  chartT: '后端',
                  UnitPrice: element.TotalWithoutCashBagProfitInfo.UnitPrice,
                });
              }
            }
          });
        }
      }
      this.holdUnitPriceLsit = aletlist;
      // this.trackLog('成本线 买卖点 请求开始');
      await this.getUserInfo();
      // #if EXECUTION_ENV === 'fund'
      // 货币基金不展示买卖点
      if (this.publicParams.Uid && !this.hasLoadHoidAndPointData && this.typeName !== 'hb') {
        this.hasLoadHoidAndPointData = true;
        // eslint-disable-next-line new-cap
        // eslint-disable-next-line no-new
        // this.trackLog('成本线 买卖点 请求完毕');
        this.unitPrice = this.holdUnitPriceLsit[this.holdUnitPriceSelectIndex]?.UnitPrice;
        if (this.getCostShowState() !== '1') {
          this.unitPrice = null;
        }
        let dataList = [];
        const blist = allBuyList;
        const slist = allSaleList;
        if (blist[0] || slist[0]) {
          this.buyAndSellPointData = {
            BuyPoints: blist,
            SellPoints: slist,
            qdBuyPoints: qdBuyList,
            qdSellPoints: qdSaleList,
            hdBuyPoints: hdBuyList,
            hdSellPoints: hdSaleList,
          };

          dataList = dataList.concat(
            blist || [],
            slist || [],
          );
          // 去重
          dataList = Array.from(new Set(dataList));
        }
        this.DATES = dataList.join(',');
        // this.publicParams.DATES = dataList.join(',');
        // this.publicParams.POINTCOUNT = 500;
        this.hadLoadUserBuyInfo = true;

        let timer = null;
        const tryAddPoint = (cb) => {
          // if (!this.hadRenderUserPoint && this.hadShowFirstScreen && this.publicParams.DATES) {
          if (!this.hadRenderUserPoint && this.hadShowFirstScreen) {
            clearInterval(timer);
            // this.trackLog('------------------------------------- reload chart');
            this.isFirstLoad = true;
            this.isReDrawing = true;
            this.updateChart();
          } else {
            // eslint-disable-next-line no-unused-expressions
            cb && cb();
          }
        };
        tryAddPoint(() => {
          timer = setInterval(tryAddPoint, 1000);
        });
      }
      // #endif
    },
    onPageShow() {
      if (this.gotobigBack) {
        let mindex = getStorageSync('ef_chart_big_main_index');
        let tindex = getStorageSync('ef_chart_big_time_index');
        if (mindex) {
          if (mindex.length <= 0) {
            mindex = 0;
          }
        }
        if (tindex) {
          if (tindex.length <= 0) {
            tindex = 3;
          }
        }
        this.gotobigBack = false;
        this.render(false, mindex, tindex);
        return;
      }
      let mindex = this.getPageCache('ef_chart_main_index');
      let tindex = this.getPageCache('ef_chart_time_index');
      if (mindex) {
        if (mindex.length <= 0) {
          mindex = 0;
        }
      }
      if (tindex) {
        if (tindex.length <= 0) {
          tindex = 3;
        }
      }
      this.render(false, mindex, tindex);
    },
    setCache(key, value) {
      window.localStorage.setItem(key, value);
      setCommonStorageSync({
        key,
        data: value,
      });
    },
    getCache(key) {
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      if (fundDetail.getCommonStorageSync) {
        console.log('fundDetail.getCommonStorageSync');
        // eslint-disable-next-line no-undef
        const v = fundDetail.getCommonStorageSync(key);
        if (v === '1') {
          return v;
        }
      }
      // #endif
      return window.localStorage.getItem(key);
    },
    setPageCache(key, value) {
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      if (fundDetail.setPageStorageSync) {
        console.log('fundDetail.setPageStorageSync');
        // eslint-disable-next-line no-undef
        fundDetail.setPageStorageSync({
          key,
          data: value,
        });
      }
      // #endif
    },
    getPageCache(key) {
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      if (fundDetail.getPageStorageSync) {
        console.log('fundDetail.getPageStorageSync');
        // eslint-disable-next-line no-undef
        const v = fundDetail.getPageStorageSync(key);
        return v;
      }
      // #endif
      return '';
    },
    getCostShowState() {
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      if (fundDetail.getCostShowStateSync) {
        console.log('fundDetail.getCostShowStateSync');
        // eslint-disable-next-line no-undef
        const v = fundDetail.getCostShowStateSync('');
        return v;
      }
      const version = multi.$system.appVersion;
      if (version >= '6.4.9') {
        // eslint-disable-next-line no-undef
        const coststate = fund.getStorageSync('eflocaldata-showcostprice', {
          prefix: 0,
          level: 'core',
        });
        console.log(`coststate ==== ${coststate}`);
        if (coststate === null || coststate === 'undefined' || coststate === '') {
          return '1';
        }
        let state = '1';
        try {
          if (typeof coststate === 'string') {
            state = JSON.parse(coststate).data;
          } else {
            state = coststate.data;
          }
        } catch (error) {
          console.log(`coststate ${error}`);
        }
        if (state) {
          return state;
        }
      }
      // #endif
      return '1';
    },
    // 手指离开时解除滑动锁定
    handleTouchend() {
      openHorizontalScroll({});
    },

    // 基金基本信息加载失败
    mainQueryError() {
      this.isLoadError = true;
      this.render();
    },

    // 加载买卖点数据
    loadUserTradeData() {
    },
    getwebGZOPen() {
      // web站估值状态
      const isOpen = new RegExp('(^| )EastMoney.wgz.open=true(;|$)').test(document.cookie);
      this.isOpenGz = isOpen;
    },
    setwebGZOPen() {
      // web站估值状态
      document.cookie = 'EastMoney.wgz.open=true; path=/; domain=.1234567.com.cn';
    },
    setGZOpenTip() {
      if (this.getCache('ef-open-fund-valuation')) {
        if (this.getCache('ef-open-fund-valuation') === '1') {
          this.isOpenGz = true;
        }
      }
      const res = getStorageSync('ef-open-fund-valuation');
      if (res && res === '1') {
        this.isOpenGz = true;
      }
      if (window.gzOpen) {
        if (window.gzOpen === 1) {
          this.isOpenGz = true;
        }
        if (window.gzOpen === '1') {
          this.isOpenGz = true;
        }
        if (window.gzOpen === 0) {
          this.isOpenGz = false;
        }
        if (window.gzOpen === '0') {
          this.isOpenGz = false;
        }
      }
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wap') {
        this.getwebGZOPen();
      }
      // #endif
    },
    async bigRender(isCache, selectIndex, selectTime) {
      this.rendered = false;
      this.render(isCache, selectIndex, selectTime);
    },
    async pageRenderchart(isCache, mainindex, timeindex) {
      console.log(`mainindex:${mainindex} timeindex:${timeindex}`);
      let mindex = this.getPageCache('ef_chart_main_index');
      let tindex = this.getPageCache('ef_chart_time_index');
      if (!mindex) {
        mindex = mainindex;
      }
      if (mindex && mindex.length === 0) {
        mindex = mainindex;
      }
      if (!tindex) {
        tindex = timeindex;
      }
      if (tindex && tindex.length === 0) {
        tindex = timeindex;
      }

      console.log(`mainindex:${mindex} timeindex:${tindex}`);
      this.render(isCache, mindex, tindex);
    },
    async pageRender(isCache) {
      let mindex = this.getPageCache('ef_chart_main_index');
      let tindex = this.getPageCache('ef_chart_time_index');
      if (mindex) {
        if (mindex.length <= 0) {
          mindex = 0;
        }
      }
      if (tindex) {
        if (tindex.length <= 0) {
          tindex = 3;
        }
      }
      this.render(isCache, mindex, tindex);
    },
    // eslint-disable-next-line no-unused-vars
    async render(isCache, selectIndex, selectTime) {
      let mindex = this.getPageCache('ef_chart_main_index');
      let tindex = this.getPageCache('ef_chart_time_index');
      if (mindex) {
        if (mindex.length <= 0) {
          mindex = 0;
        }
      }
      if (tindex) {
        if (tindex.length <= 0) {
          tindex = 3;
        }
      }
      // 估值开启
      this.setGZOpenTip();
      // this.trackLog('图表：', 'render开始', { isCache, selectIndex, selectTime });
      // this.trackLog('图表：render开始');

      await this.getUserInfo();
      // #if EXECUTION_ENV === 'fund'
      if (window.innerWidth < 200) {
        // eslint-disable-next-line no-undef
        const systemInfo = fund.getSystemInfoSync();
        window.innerWidth = systemInfo.windowWidth / systemInfo.pixelRatio;
        this.innerWidth = systemInfo.windowWidth / systemInfo.pixelRatio;
      }
      // #endif

      const { fundCode } = this.$store.state.native.fund;
      this.FCODE = fundCode || '000001';
      this.baseInfo = StoreManger.getFundJJXQ() || {};
      this.isLoadError = false;

      if (!this.isFirstLoad && !this.baseInfo) {
        this.isNoData = true;
        console.log('isNoData');
        return;
      }

      const {
        FEATURE, FUNDTYPE, BFUNDTYPE, ESTDIFF,
      } = this.baseInfo;

      this.ESTDIFF = ESTDIFF;
      // 设置显示类型
      this.setTabType();

      try {
        // 是否是净值型货币和净值型理财基金
        // eslint-disable-next-line no-unused-expressions
        (/^205$/.test(FUNDTYPE) && /^004|005$/.test(BFUNDTYPE)) && (this.typeName = 'jz');

        // 货币基金收益单份数
        this.hbTitleUnit = '万';
        if (FEATURE && FEATURE.indexOf) {
          if (FEATURE.indexOf('090') !== -1) {
            this.hbTitleUnit = '百万';
          } else if (FEATURE.indexOf('100') !== -1) {
            this.hbTitleUnit = '百';
          }
        }
      } catch (err) {
        console.error(err);
      }

      // 是否已退市
      try {
        const endDate = new Date(this.baseInfo.TSRQ.replace(/-/g, '/')).getTime();
        const serverDate = new Date().getTime();
        if (this.typeName === 'normal' && serverDate > endDate) {
          this.typeName = 'normalts';
        }
      } catch (err) {
        // console.error(err);
      }

      // 退市不显示净值估算

      // 判断目前是否在交易时间

      // 成立时长
      try {
        const d = new Date();
        let year = 0;
        // eslint-disable-next-line no-throw-literal
        if (!tools.hasData(this.baseInfo.ESTABDATE)) throw 'no data';

        const lastArr = this.baseInfo.ESTABDATE.split('-');
        const curArr = lastArr.concat([]);
        curArr[1] -= 1;
        curArr[0] -= 0;
        curArr[0] += year;
        const nowArr = [d.getFullYear(), d.getMonth(), d.getDate()];

        while (new Date(...curArr).getTime() < new Date(...nowArr).getTime()) {
          curArr[0] += 1;
          if (new Date(...curArr).getTime() < new Date(...nowArr).getTime()) {
            year += 1;
          }
        }
        curArr[0] -= 1;

        const nowDt = new Date(...nowArr).getTime();
        const curDt = new Date(...curArr).getTime();
        const days = (nowDt - curDt) / (1000 * 60 * 60 * 24);

        this.ESTABYEAR = year;
        this.ESTABDAY = days;
        this.ESTABTimeLength = `${year > 0 ? `${year}年` : ''}${days}天`;
      } catch (err) {
        this.ESTABYEAR = 0;
        this.ESTABDAY = 0;
        this.ESTABTimeLength = '0天';
        // console.error(err);
      }
      this.rendered = true;
      const defaultIndex = FundTypeSearch.isGoldFund(this.fundType) ? 3 : null;
      // 货币和理财基金进入品种页走势图周期默认定位到近3月上(其总要求改成1年)
      // const hbTimeIndex = FundTypeSearch.isMonetaryfund(this.fundType) ? 3 : null;
      this.isQDII = FundTypeSearch.isQDIIFund(this.fundType);

      const { chartList } = config.type[this.typeName];
      const lastTypeIndex = chartList.length - 1;
      const lastTimeIndex = config.timeList.length - 1;

      // eslint-disable-next-line max-len
      const nextTypeIndex = Math.min((defaultIndex || selectIndex) || this.typeIndex, lastTypeIndex);
      let nextTimeIndex = Math.min(selectTime || this.timeIndex, lastTimeIndex);
      console.log(`nextTypeIndex:${nextTypeIndex}    nextTimeIndex:${nextTimeIndex}`);
      if (chartList[0].name === '累计收益') {
        nextTimeIndex = Math.min(selectTime || this.timeIndex, lastTimeIndex);
      }
      console.log(`nextTypeIndex:${nextTypeIndex}    nextTimeIndex:${nextTimeIndex}`);
      if (this.typeIndex !== nextTypeIndex && this.timeIndex === nextTimeIndex) {
        // 只有tab类型变了
        await this.updateChart('typeIndex', nextTypeIndex, false);
      } else if (this.timeIndex !== nextTimeIndex && this.typeIndex === nextTypeIndex) {
        // 只有时间类型变了
        await this.updateChart('timeIndex', nextTimeIndex, false);
      } else {
        // 都变了
        this.timeIndex = nextTimeIndex;
        await this.updateChart('typeIndex', nextTypeIndex, false);
      }
      if (this.isNoData) {
        this.isFirstLoad = true;
        this.timeIndex = nextTimeIndex;
        await this.updateChart('typeIndex', nextTypeIndex, false);
      }

      console.warn('render开始', this.timeIndex);

      this.isFirstLoad = false;
      // this.trackLog('图表：render结束');
      // this.showMark();
      if (!isCache) {
        this.trackSend();
      }
    },
    showMark() {
    },
    // 刷新图表
    reload() {
      this.isFirstLoad = true;
      this.updateChart();
    },

    // 设置tab类型
    setTabType() {
      this.fundType = this.$store.state.native.fund.fundType || this.$props.baseType;
      // 设置显示类型
      this.isMonetaryfund = FundTypeSearch.isMonetaryfund(this.fundType);
      // 货币
      // eslint-disable-next-line no-unused-expressions
      FundTypeSearch.isMonetaryfund(this.fundType) && (this.typeName = 'hb');
      // 黄金
      // eslint-disable-next-line no-unused-expressions
      FundTypeSearch.isGoldFund(this.fundType) && (this.typeName = 'gold');
      // 场内
      // eslint-disable-next-line no-unused-expressions
      FundTypeSearch.isExchangeFund(this.fundType) && (this.typeName = 'onSite');
      // FOF
      // eslint-disable-next-line no-unused-expressions
      FundTypeSearch.isFOFFund(this.fundType) && (this.typeName = 'fof');

      // eslint-disable-next-line no-unused-expressions
      !this.typeName && (this.typeName = 'normal');
    },

    // 判断是否显示时间区间
    toggleShowTimeTab() {
      const chartConfig = config.type[this.typeName];
      // 有报错 做个兼容
      if (chartConfig.chartList[this.typeIndex]) {
        const cname = chartConfig.chartList[this.typeIndex].name;
        if (this.config.withoutTimeList.indexOf) {
          return this.config.withoutTimeList.indexOf(cname) === -1;
        }
      }
      return false;
    },

    // 获取涨幅颜色
    getRiseClassName(val) {
      return (
        // eslint-disable-next-line no-mixed-operators
        val > 0 && 'font-color-red'
          // eslint-disable-next-line no-mixed-operators
          || (val < 0 && 'font-color-green')
          || 'font-color-normal'
      );
    },

    // 显示更多时间选择
    showMoreTime() {
      const { typeIndex } = this;
      const chart = config.type[this.typeName].chartList[typeIndex];

      // 打点
      let trackType = 'zs';
      // eslint-disable-next-line no-unused-expressions
      (this.typeName === 'hb') && (trackType = 'zsh');
      // eslint-disable-next-line no-unused-expressions
      (this.typeName === 'onSite') && (trackType = 'cnsh');
      const eventName = `pz.${trackType}.${chart.track}all`;
      this.reportMonitor({
        eventName,
      });

      const moreList = config.timeList.slice(this.showTimeBtnNum);
      const itemList = [];
      const itemColor = [];
      // eslint-disable-next-line array-callback-return
      moreList.map((time, index) => {
        const name = /成/.test(time.name) && this.ESTABTimeLength ? `${time.name} (${this.ESTABTimeLength})` : time.name;
        itemList.push(name);
        itemColor.push(this.timeIndex === (this.showTimeBtnNum + index) ? '#FF4400' : '#000000');
      });

      this.$feedback.showActionSheet({
        itemList,
        itemColor,
        cancelText: '取消',
        cancelColor: '#000',
        success: ({ tapIndex }) => {
          this.updateChart('timeIndex', tapIndex + this.showTimeBtnNum, true);
        },
        fail(res) {
          console.log(res);
        },
      });
    },

    // 更多指数
    showMoreIndex(index) {
      if (index === 1) {
        this.$feedback.showModal({
          title: '',
          content: '平台采用最新同类分类，在原有一级分类基础上按照资产维度向下细分，用更加科学的方法计算平均值做参考。如：混合型-偏股、混合型-偏债。',
          confirmText: '知道了',
          cancelText: '了解详情',
          confirmColor: '#ff4400',
          cancelColor: '#000000',
          showCancel: true,
          success: (res) => {
            if (res.confirm) {
              console.log('用户点击确定');
            } else if (res.cancel) {
              console.log('用户点击取消');
              detailPushPage({
                appId: 'funda310cd172dd395',
                url: '/pages/questionDetail/index?id=1361',
              });
            }
          },
        });
        return;
      }
      if (index === 3) {
        this.$feedback.showModal({
          title: '业绩比较基准',
          content: `当前基金的业绩比较基准公式：${this.baseInfo.BENCH}。\n业绩比较基准是管理人制定的反映基金风险收益特征的重要指标，业绩比较基准仅供参考，不构成基金业绩表现的保证。\n说明：为确保数据准确性对于成立时长超过5年的基金仅展示近5年业绩基准数据，若近5年业绩基准计算方法有变更则为变更前后的累加数据；因业绩基准会多次变更仅展示最新业绩基准计算方法；展示“--”为数据更新时间或无数据。`,
          confirmText: '知道了',
          confirmColor: '#f40',
          showCancel: false,
        });
        return;
      }
      const eventName = 'pzy.zst.qhzs.click';
      this.reportMonitor({
        eventName,
      });
      const itemList = [];
      const itemColor = [];
      // eslint-disable-next-line array-callback-return
      config.indexList.map((data) => {
        itemList.push(data.name);
        itemColor.push(data.code === this.indexCode ? '#FF4400' : '#000000');
      });
      this.hidLJSYzsTip();
      this.$feedback.showActionSheet({
        itemList,
        itemColor,
        cancelText: '取消',
        cancelColor: '#000000',
        success: ({ tapIndex }) => {
          // this.updateChart('timeIndex', tapIndex + this.showTimeBtnNum)
          // this.indexCode = config.indexList[tapIndex].code;
          this.indexName = config.indexList[tapIndex].name;
          this.updateChart('indexCode', config.indexList[tapIndex].code, true);
        },
        fail(res) {
          console.log(res);
        },
      });
    },
    // 跟新交易数据
    updateUserUnitPriceData() {
      this.unitPrice = this.holdUnitPriceLsit[this.holdUnitPriceSelectIndex]?.UnitPrice;
      if (this.getCostShowState() !== '1') {
        this.unitPrice = null;
      }
      this.isFirstLoad = true;
      this.isReDrawing = true;
      this.updateChart();
    },
    // 更新图表
    async updateChart(key, value = 0, isFromClick) {
      console.log(`${key} -----------0000 ------${value}`);
      console.log(`${this.typeIndex} -----------0000 ------${this.timeIndex}`);
      this.hidLJSYzsTip();
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp') {
        // eslint-disable-next-line no-undef
        console.log(wx);
        // eslint-disable-next-line no-undef
        if (wx.miniProgram && wx.miniProgram.postMessage) {
          // eslint-disable-next-line no-undef
          wx.miniProgram.postMessage({ data: this.isOpenGz ? '1' : '0' });
        }
      }
      // #endif
      // 基金基础信息加载失败时禁止切换tab
      // console.log('sdasdasdasda 1');
      if (!this.rendered || this.isLoadError) return;
      // console.log('sdasdasdasda 2');
      if (window.isShowingToolTips) {
        this.isReDrawing = false;
        return;
      }
      // console.log('sdasdasdasda 3');
      // if (!this.isFirstLoad) {
      //   window.location.href = '#market-chart-tab';
      // }
      const FCODE = JS.fetchString(this.baseInfo, 'FCODE');
      const LISTTEXCH = JS.fetchString(this.baseInfo, 'LISTTEXCH');

      // 相同属性的设置不会触发刷新
      // eslint-disable-next-line no-unused-expressions
      if ((key && this[key] !== value) || this.isFirstLoad || this.isReDrawing) {
        this.isFirstLoad = false;
        if (key) {
          this[key] = value;
        }
      } else {
        console.log('相同属性的设置不会触发刷新', key, value);
        return;
      }
      if (key === 'typeIndex' && isFromClick) {
        this.setPageCache('ef_chart_main_index', value);
      }
      if (key === 'timeIndex' && isFromClick) {
        this.setPageCache('ef_chart_time_index', value);
      }
      // this.trackLog('图表：', '刷新开始', { key, value, isReDrawing: this.isReDrawing });
      // this.trackLog('图表：刷新开始');

      // 判断是否有用户买卖信息
      const checkIfNeedReload = () => {
        // this.trackLog('判断是否有用户买卖信息');
        // eslint-disable-next-line no-unused-expressions
        this.hadLoadUserBuyInfo && (this.hadRenderUserPoint = true);
      };
      checkIfNeedReload();

      const {
        typeIndex, timeIndex, publicParams, buyAndSellPointData, changeSlideState, alertTips,
      } = this;
      const time = config.timeList[timeIndex];
      const chart = config.type[this.typeName].chartList[typeIndex];
      const exist = !!chart.f2;
      let row = {};
      let data = [];
      let lastPoint = {};
      let hadyj = true;

      // 打点
      let trackType = 'zs';
      // eslint-disable-next-line no-unused-expressions
      (this.typeName === 'hb') && (trackType = 'zsh');
      // eslint-disable-next-line no-unused-expressions
      (this.typeName === 'onSite') && (trackType = 'cnsh');
      let eventName = `pz.${trackType}.${chart.track}`;
      if (key === 'timeIndex') {
        // 场内净值1年用“y”;
        if (this.typeName === 'onSite' && time.name === '近1年') {
          time.track = 'y';
        }
        eventName += time.track;
      }
      if (isFromClick) {
        this.reportMonitor({
          eventName,
        });
      }

      // 创建图表实例
      if (!chart.f2 && !/分|K/.test(chart.name)) {
        // #if EXECUTION_ENV === 'fund'
        if (window.innerWidth < 200) {
          // eslint-disable-next-line no-undef
          const systemInfo = fund.getSystemInfoSync();
          window.innerWidth = systemInfo.windowWidth / systemInfo.pixelRatio;
        }
        // #endif
        // if (!document.getElementById(chart.id)) {
        //   // eslint-disable-next-line no-shadow
        //   await new Promise((resolve) => {
        //     const timer = setInterval(() => {
        //       if (document.getElementById(chart.id)) {
        //         clearInterval(timer);
        //         resolve();
        //       }
        //     }, 10);
        //   });
        // }
        await new Promise((resolve) => this.$nextTick(resolve));
        chart.f2 = new F2.Chart({
          id: chart.id,
          pixelRatio: window.devicePixelRatio,
          width: window.innerWidth - 30,
          padding: [-10, 'auto', 'auto', 'auto'],
        });
      }

      this.isLoading = !/分|K/.test(chart.name);
      this.isNoData = false;

      if (this.isReDrawing && this.hadShowFirstScreen) {
        this.isLoading = false;
      }
      this.onLineChartUrl = '';

      // await new Promise((resolve) => setTimeout(resolve, 3000));
      const klineapi = 'https://appunit.1234567.com.cn';
      // https://appunit.1234567.com.cn/FundType/chart/?id=1598632&type=DK&chartType=K&random=3928877514&delaytouch=1&_=0.48036057480694416
      // eslint-disable-next-line default-case
      switch (chart.name) {
        case '累计收益':
          // 缓存用户现在的时间区间
          this.setSelectTimeIndex();
          // 加载数据
          if (time.code === '5n' || time.code === 'ln') {
            publicParams.POINTCOUNT = 500;
          } else {
            publicParams.POINTCOUNT = '';
          }
          row = await Model.FundMNYieldDiagramAcc(publicParams, this.indexCode, FCODE, time.code);
          // this.trackLog('图表接口请求结束', row);
          // 判断是否需要提示“网络不给力，点击重试”
          this.isShowNetErrorTips = row?.errorMsg === 'NET_ERROR';
          if (this.isShowNetErrorTips) { this.isLoading = false; return; }
          // 判断是否空数据
          this.isNoData = !row.Datas || !row.Datas.length;
          if (this.isNoData) { this.isLoading = false; return; }
          // 限制长度在500内
          row.Datas = this.limitDataLen('YIELD', row.Datas, row.Expansion?.FundMNChangeList);
          // this.trackLog('限制长度在500内', buyAndSellPointData);
          // 基金指定的指数列表
          this.setTargetIndexList(row.Expansion.FundMNYieldBase);
          // this.trackLog('基金指定的指数列表');
          // 格式化数据
          hadyj = true;
          if (row) {
            if (row.Datas) {
              if (row.Datas.length > 3) {
                if (!row.Datas[row.Datas.length - 1].BENCCHQUOTE
                  && !row.Datas[row.Datas.length - 2].BENCCHQUOTE) {
                  hadyj = false;
                }
              }
            }
          }
          this.isShowyj = hadyj;
          data = drawTotalRevenue.formatData(
            row, buyAndSellPointData, time.name, this.indexName, hadyj,
          );
          // this.trackLog('格式化数据');
          // 设置图例数据
          lastPoint = row.Datas[row.Datas.length - 1];
          this.total_revenue_legend.last = [
            lastPoint.YIELD, // 0 本基金
            lastPoint.FUNDTYPEYIED, // 1 同类基金
            lastPoint.INDEXYIED, // 2 指数
            lastPoint.BENCCHQUOTE, // 2 指数
          ];
          console.log('累计收益', '设置图例数据', this.total_revenue_legend.last);
          // 创建图表
          chart.f2.clear();
          // eslint-disable-next-line no-unused-expressions
          drawTotalRevenue.drawChart(data, chart.f2, alertTips, this.indexName,
            changeSlideState, this.isReDrawing,
            // eslint-disable-next-line no-return-assign
            (arr) => this.total_revenue_legend.active = arr, hadyj);
          // this.trackLog('绘制图表');
          // 显示指引
          setTimeout(() => {
            this.needshowHdTip();
          }, 1000);
          break;

        case '净值':
        case '单位净值':
          // 缓存用户现在的时间区间
          this.setSelectTimeIndex();
          // 加载数据
          if (time.code === '5n' || time.code === 'ln') {
            publicParams.POINTCOUNT = 500;
          } else {
            publicParams.POINTCOUNT = '';
          }
          row = await Model.FundMNNetDiagram(publicParams, FCODE, time.code);
          // this.trackLog('图表接口请求结束');
          // 判断是否需要提示“网络不给力，点击重试”
          this.isShowNetErrorTips = row?.errorMsg === 'NET_ERROR';
          if (this.isShowNetErrorTips) { this.isLoading = false; return; }
          // 判断是否空数据
          this.isNoData = !row.Datas || !row.Datas.length;
          if (this.isNoData) { this.isLoading = false; return; }
          // 限制长度在500内
          row.Datas = this.limitDataLen('DWJZ', row.Datas, row.Expansion?.FundMNChangeList);
          console.log('单位净值', row);
          // 格式化数据
          data = drawUnitNet.formatData(row, buyAndSellPointData, time.code);
          // 判断是否显示均摊单价
          this.judgeShowUnitPrice(data);
          // 设置图例数据
          lastPoint = row.Datas[row.Datas.length - 1];
          this.unit_net_legend.last = [
            lastPoint.FSRQ, // 0 日期
            lastPoint.DWJZ, // 1 单位净值
            lastPoint.JZZZL, // 2 涨幅
          ];
          // 创建图表
          chart.f2.clear();
          // eslint-disable-next-line no-unused-expressions
          drawUnitNet.drawChart(data, chart.f2, alertTips, changeSlideState, this.unitPrice,
            this.showUnitPrice, this.isReDrawing,
            // eslint-disable-next-line no-return-assign
            (arr) => this.unit_net_legend.active = arr);
          // 显示指引
          setTimeout(() => {
            this.needshowHdTip();
          }, 1000);
          break;

        case '累计净值':
          // 缓存用户现在的时间区间
          this.setSelectTimeIndex();
          // 加载数据
          if (time.code === '5n' || time.code === 'ln') {
            publicParams.POINTCOUNT = 500;
          } else {
            publicParams.POINTCOUNT = '';
          }
          row = await Model.FundMNNetDiagram(publicParams, FCODE, time.code);
          // 判断是否需要提示“网络不给力，点击重试”
          this.isShowNetErrorTips = row?.errorMsg === 'NET_ERROR';
          if (this.isShowNetErrorTips) { this.isLoading = false; return; }
          // 判断是否空数据
          // eslint-disable-next-line no-case-declarations
          let hadData = false;
          if (row.Datas) {
            // eslint-disable-next-line array-callback-return
            row.Datas.map((d) => {
              if (d.LJJZ) {
                hadData = true;
              }
            });
          }
          this.isNoData = !row.Datas || !row.Datas.length || !hadData;
          if (this.isNoData) { this.isLoading = false; return; }
          // 限制长度在500内
          row.Datas = this.limitDataLen('LJJZ', row.Datas, row.Expansion?.FundMNChangeList);
          console.log('累计净值', row);
          // 格式化数据
          data = drawTotalNet.formatData(row, buyAndSellPointData, time.code);
          // 设置图例数据
          lastPoint = row.Datas[row.Datas.length - 1];
          this.total_net_legend.last = [
            lastPoint.FSRQ, // 0 日期
            lastPoint.LJJZ, // 1 单位净值
          ];
          // 创建图表
          chart.f2.clear();
          // eslint-disable-next-line no-unused-expressions
          drawTotalNet.drawChart(data, chart.f2, alertTips, this.changeSlideState,
            this.isReDrawing,
            // eslint-disable-next-line no-return-assign
            (arr) => this.total_net_legend.active = arr);
          // 显示指引
          setTimeout(() => {
            this.needshowHdTip();
          }, 1000);
          break;

        case '净值估算':
          this.hdmmdtipshow = false;
          try {
            // 加载数据
            try {
              row = await Model.FundVarietieValuationDetail(publicParams, FCODE);
            } catch (err) {
              console.error(err);
            }
            console.log('净值估算', row);
            // 判断是否需要提示“网络不给力，点击重试”
            this.isShowNetErrorTips = row?.errorMsg === 'NET_ERROR';
            if (this.isShowNetErrorTips) { this.isLoading = false; return; }
            // 判断是否空数据
            this.isNoData = !row.Datas || !row.Datas.length || !row.Datas[0];
            if (this.isNoData) { this.isLoading = false; return; }
            if (row.Expansion.DWJZ === '-' || row.Expansion.DWJZ === '--') {
              this.hadDWJZ = false;
            }
            if (row.Expansion.DWJZ === 0) {
              this.hadDWJZ = false;
            }
            // 格式化数据
            // eslint-disable-next-line no-shadow
            const { data, lastPoint } = gsWorth.formatData(row, this.fundType);
            // 判断是否显示均摊单价
            this.judgeShowUnitPrice(data);
            this.netWorthFormatData = data;
            try {
              // 设置图例数据
              this.net_worth_legend.last = [
                lastPoint.date, // 0 日期
                lastPoint.gs, // 1 估值
                lastPoint.rise, // 2 涨幅
              ];
            } catch (err) {
              console.error(err);
            }
            // 设置数据更新日期
            // eslint-disable-next-line prefer-destructuring
            this.nowDate = row?.Expansion?.GZTIME.split(' ')[0] || '--';
            if (this.nowDate !== '--') {
              if (this.nowDate.split('-').length === 3) {
                const riq = `${this.nowDate.split('-')[1]}-${this.nowDate.split('-')[2]}`;
                this.nowDate = riq;
              }
            }
            // 创建图表
            chart.f2.clear();
            // eslint-disable-next-line no-unused-expressions
            // chart.yTipsGuide && chart.yTipsGuide.remove();
            // eslint-disable-next-line no-unused-expressions
            gsWorth.drawChart(row, data, chart.f2, this.changeSlideState, null,
              this.showUnitPrice,
              // eslint-disable-next-line no-return-assign
              (arr) => this.net_worth_legend.active = arr);
            // 刷新图表
            // if (exist) {
            //   chart.f2.changeData(data);
            //   chart.f2.yTipsGuide.remove();
            // }
          } catch (err) { console.error(err); }
          break;

        case '万元收益':
          // 加载数据
          if (time.code === '5n' || time.code === 'ln') {
            publicParams.POINTCOUNT = 500;
          } else {
            publicParams.POINTCOUNT = '';
          }
          row = await Model.FundMNNetDiagram(publicParams, FCODE, time.code);
          // 判断是否需要提示“网络不给力，点击重试”
          this.isShowNetErrorTips = row?.errorMsg === 'NET_ERROR';
          if (this.isShowNetErrorTips) { this.isLoading = false; return; }
          // 判断是否空数据
          this.isNoData = !row.Datas || !row.Datas.length;
          // 限制长度在500内
          row.Datas = this.limitDataLen('DWJZ', row.Datas, row.Expansion?.FundMNChangeList);
          if (this.isNoData) { this.isLoading = false; return; }
          // 格式化数据
          data = drawMarket10000SharesProfit.formatData(
            row,
            buyAndSellPointData,
            time.name,
            this.indexName,
          );
          // 设置图例数据
          lastPoint = row.Datas[row.Datas.length - 1];
          this.wan_profit_legend.last = [
            lastPoint.FSRQ, // 0 日期
            lastPoint.DWJZ, // 1 万份收益
            lastPoint.LJJZ, // 2 7日年化
          ];
          // 创建图表
          chart.f2.clear();
          // eslint-disable-next-line no-unused-expressions
          drawMarket10000SharesProfit.drawChart(data, chart.f2, alertTips,
            this.changeSlideState, this.isReDrawing,
            // eslint-disable-next-line no-return-assign
            (arr) => this.wan_profit_legend.active = arr);
          break;

        case '7日年化':
          // 加载数据
          if (time.code === '5n' || time.code === 'ln') {
            publicParams.POINTCOUNT = 500;
          } else {
            publicParams.POINTCOUNT = '';
          }
          row = await Model.FundMNNetDiagram(publicParams, FCODE, time.code);
          // 判断是否需要提示“网络不给力，点击重试”
          this.isShowNetErrorTips = row?.errorMsg === 'NET_ERROR';
          if (this.isShowNetErrorTips) { this.isLoading = false; return; }
          // 判断是否空数据
          this.isNoData = !row.Datas || !row.Datas.length;
          if (this.isNoData) { this.isLoading = false; return; }
          // 限制长度在500内
          row.Datas = this.limitDataLen('LJJZ', row.Datas, row.Expansion?.FundMNChangeList);
          console.log('7日年化', row);
          // 格式化数据
          data = drawMarket7daysProfit.formatData(
            row,
            buyAndSellPointData,
            time.name,
            this.indexName,
          );
          // 设置图例数据
          lastPoint = row.Datas[row.Datas.length - 1];
          this.seven_profit_legend.last = [
            (lastPoint.LJJZ - 0).toFixed(4), // 0 7日年化
            (lastPoint.RATE - 0).toFixed(2), // 1 一年期定存
          ];
          // 创建图表
          chart.f2.clear();
          // eslint-disable-next-line no-unused-expressions
          drawMarket7daysProfit.drawChart(data, chart.f2, alertTips,
            this.changeSlideState, this.isReDrawing,
            // eslint-disable-next-line no-return-assign
            (arr) => this.seven_profit_legend.active = arr);
          break;

        case '金价走势':
          // 加载数据
          row = await Model.FundGoldDiagram(publicParams, FCODE, time.code);
          console.log('金价走势', row);
          // 判断是否需要提示“网络不给力，点击重试”
          this.isShowNetErrorTips = row?.errorMsg === 'NET_ERROR';
          if (this.isShowNetErrorTips) { this.isLoading = false; return; }
          // 判断是否空数据
          this.isNoData = !row.Datas || !row.Datas.length;
          if (this.isNoData) { this.isLoading = false; return; }
          // 格式化数据
          data = drawMarketGold.formatData(row, time.name, this.indexName);
          // 设置图例数据
          lastPoint = row.Datas[row.Datas.length - 1];
          this.gold_legend.last = [
            lastPoint.PDATE, // 0 日期
            lastPoint.PERCENTPRICE, // 1 金价
            lastPoint.CHGRT, // 2 日涨幅
          ];
          // 创建图表
          // eslint-disable-next-line no-unused-expressions
          !exist && drawMarketGold.drawChart(data, chart.f2, this.changeSlideState,
            // eslint-disable-next-line no-return-assign
            (arr) => this.gold_legend.active = arr);
          // 刷新图表
          // eslint-disable-next-line no-unused-expressions
          exist && chart.f2.changeData(data);
          break;

        case '分时':
          this.createIframe(`${klineapi}/FundType/chart/?id=${FCODE}${LISTTEXCH}&type=T&chartType=T&random=3076537131&delaytouch=1&_=${Math.random()}`);
          break;
        case '日K':
          this.createIframe(`${klineapi}/FundType/chart/?id=${FCODE}${LISTTEXCH}&type=DK&chartType=K&random=3928877514&delaytouch=1&_=${Math.random()}`);
          break;
        case '周K':
          this.createIframe(`${klineapi}/FundType/chart/?id=${FCODE}${LISTTEXCH}&type=WK&chartType=K&random=2047409334&delaytouch=1&_=${Math.random()}`);
          break;
        case '月K':
          this.createIframe(`${klineapi}/FundType/chart/?id=${FCODE}${LISTTEXCH}&type=MK&chartType=K&random=490687202&delaytouch=1&_=${Math.random()}`);
          break;
      }

      this.isReDrawing = false;
      this.isLoading = false;
      this.hadShowFirstScreen = true;
      // this.trackLog('图表：刷新结束');
    },

    // 获取用户选择的时间(累计收益、单位净值、累计净值)
    setSelectTimeIndex() {
      try {
        localStorage.setItem(this.timeIndexCacheId, this.timeIndex);
      // eslint-disable-next-line no-empty
      } catch (err) {}
    },

    // 获取用户选择的时间(累计收益、单位净值、累计净值)
    getSelectTimeIndex() {
      // let index = this.timeIndex;
      // try {
      //   index = localStorage.getItem(this.timeIndexCacheId) || this.timeIndex;
      // // eslint-disable-next-line no-empty
      // } catch (err) {}
      // return index;
      return this.timeIndex;
    },

    // 创建行情图内嵌网页
    createIframe(src) {
      this.isShowNetErrorTips = false;
      // 判断网络
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      fund.getNetworkType({
        success: (res) => {
          if (res.networkType === 'none') {
            // sss
          } else {
            this.loadKlineWebView(src);
          }
        },
      });
      // #endif
      // #if EXECUTION_ENV == 'web'
      this.loadKlineWebView(src);
      // #endif
    },
    loadKlineWebView(src) {
      this.onLineChartUrl = src;
      this.$nextTick(async () => {
        const { id } = this.config.type[this.typeName].chartList[this.typeIndex];
        window.document.getElementById(id).innerHTML = `
          <iframe class="on-line-chart-frame" src="${src}"><iframe>
        `;
        // this.onLineChartUrl = src;
        console.log(`=========== ${this.onLineChartUrl}`);
      });
    },
    // 切换提示显示状态
    changeSlideState(bool) {
      this.isSliding = bool;
    },

    // 提示
    alertTips(content, appLink, webLink) {
      const FCODE = JS.fetchString(this.baseInfo, 'FCODE');
      const FName = JS.fetchString(this.baseInfo, 'SHORTNAME');
      if (appLink || webLink) {
        const link = appLink.replace('{fcode}', FCODE);
        const linkmian = link.replace('{fname}', FName);
        this.$feedback.showModal({
          title: '',
          content,
          cancelText: '知道了',
          confirmText: '详情',
          confirmColor: '#FF4400',
          showCancel: true,
          success: (d) => {
            if (d.confirm) {
              detailPushPage({
                type: 1,
                url: linkmian,
              });
            }
          },
        });
      } else {
        this.$feedback.showModal({
          title: '',
          content,
          confirmText: '知道了',
          confirmColor: '#FF4400',
          showCancel: false,
        });
      }
      if (content.indexOf('基金分红') !== -1) {
        this.reportMonitor({
          eventName: 'pzy.zst.fhbs.click',
        });
      }
    },

    // 基金指定的指数列表
    setTargetIndexList(FundMNYieldBase) {
      const list = FundMNYieldBase;

      if (!this.targetIndex && list[2]) {
        // eslint-disable-next-line prefer-destructuring
        this.targetIndex = list[2];
        this.indexCode = list[2].INDEXCODE;
        this.indexName = list[2].INDEXNAME.length > 0 ? list[2].INDEXNAME : '--';

        if (!tools.hasData(this.indexName)) return;

        // eslint-disable-next-line array-callback-return
        config.indexList.map((c, index) => {
          if (c.code === this.indexCode) {
            config.indexList.splice(index, 1);
          }
        });

        config.indexList.splice(0, 0, { name: this.indexName, code: this.indexCode });
      }
    },

    // 折线图数据限制在500个点内
    limitDataLen(key, data) {
      return data;
    },

    // 判断是否显示分摊单价
    judgeShowUnitPrice(data) {
      // 确保上下限的点不被删
      let min = null;
      let max = null;
      // eslint-disable-next-line array-callback-return
      data.map((d) => {
        // eslint-disable-next-line no-unused-expressions
        (!min || d.value < min.value) && (min = d);
        // eslint-disable-next-line no-unused-expressions
        (!max || d.value > max.value) && (max = d);
      });
      if (this.getCostShowState() !== '1') {
        this.unitPrice = null;
      }
      if (
        this.unitPrice !== null
        && min.value <= this.unitPrice
        && max.value >= this.unitPrice
      ) {
        this.showUnitPrice = true;
      }
    },
    // 弹框提示
    alertCostAlertTips() {
      if (this.holdUnitPriceLsit.length <= 1) {
        return;
      }
      const itemList = [];
      const itemColor = [];
      // eslint-disable-next-line array-callback-return
      this.holdUnitPriceLsit.map((data, index) => {
        itemList.push(data.title);
        itemColor.push(this.holdUnitPriceSelectIndex === index ? '#FF4400' : '#000000');
      });
      this.$feedback.showActionSheet({
        itemList,
        itemColor,
        cancelText: '取消',
        cancelColor: '#000000',
        success: ({ tapIndex }) => {
          this.holdUnitPriceSelectIndex = tapIndex;
          this.updateUserUnitPriceData();
        },
        fail(res) {
          console.log(res);
        },
      });
    },
    // 弹框提示摊薄成本单价
    alertCostTips() {
      this.$feedback.showModal({
        title: '温馨提示',
        content: '摊薄单价是您当前持有该基金的每份平均成本，如果赎回的净值高于当前摊薄单价，赎回确认后摊薄单价会下降',
        confirmText: '知道了',
        confirmColor: '#FF4400',
        showCancel: false,
      });
    },
    jumpToBigCharthunhe() {
      this.gotobigBack = true;
      const {
        fundCode, fundType,
      } = this.$store.state.native.fund;
      const nativeData = {
        fCode: fundCode,
        sType: fundType,
        chartType: this.typeIndex,
        timeType: this.timeIndex,
      };
      gotoJumpBigChartView({
        loadPath: 'chart.html',
        data: nativeData,
      }).then(() => {
        // 在这里反返回大图的标签
      }).catch(() => {

      });
    },
    jumpToBigChartyuanshen() {
      const eventName = 'pz.hpzst.open';
      this.reportMonitor({
        eventName,
      });
      console.log('跳转 大图');
      // 原生大图
      /**
        * fundCode
        * fundType
        * market
        * mainType
        * timeType
        * costPrice
        * wfsyTip
      */
      console.log('=========jumpToBigChart');
      const {
        fundCode,
      } = this.$store.state.native.fund;
      this.FCODE = fundCode || '000001';
      this.fundType = this.$store.state.native.fund.fundType;
      const {
        FEATURE, FUNDTYPE, BFUNDTYPE,
      } = this.baseInfo;
      const chartConfig = config.type[this.typeName];
      let unit = '万';
      if (FEATURE.indexOf('090') !== -1) {
        unit = '百万';
      } else if (FEATURE.indexOf('100') !== -1) {
        unit = '百';
      }
      const LISTTEXCH = JS.fetchString(this.baseInfo, 'LISTTEXCH');
      let mt = '';
      if (chartConfig) {
        mt = chartConfig.chartList[this.typeIndex].name.replace('万份', `${this.hbTitleUnit}份`);
      }
      const TSRQ = JS.fetchString(this.baseInfo, 'TSRQ');
      if (mt === '万元收益') {
        mt = `${unit}份收益`;
      }

      gotoBigChartView({
        fundCode: this.FCODE,
        fundType: this.fundType,
        mainType: mt,
        timeType: config.timeList[this.timeIndex].name,
        market: LISTTEXCH,
        wfsyTip: mt,
        FEATURE,
        FUNDTYPE,
        BFUNDTYPE,
        TSRQ,
      }).then((data) => {
        // 在这里反返回大图的标签
        const nextTypeIndex = chartConfig.chartList.filter((c) => c.name === data.mainType);
        const nextTimeIndex = chartConfig.timeList.filter((c) => c.name === data.timeType);

        const typeChange = nextTypeIndex !== this.typeIndex;
        const timeChange = nextTimeIndex !== this.timeIndex;
        if (typeChange && timeChange) {
          this.timeIndex = nextTimeIndex;
          this.updateChart('typeIndex', nextTypeIndex);
        } else if (typeChange && !timeChange) {
          this.updateChart('typeIndex', nextTypeIndex);
        } else if (!typeChange && timeChange) {
          this.updateChart('timeIndex', nextTypeIndex);
        }
      }).catch(() => {

      });
    },
    // 跳转 大图
    jumpToBigChart() {
      const userBTest = true;
      if (userBTest) {
        this.jumpToBigCharthunhe();
      } else {
        this.jumpToBigChartyuanshen();
      }
      // this.jumpToBigCharthunhe();
    },

    // 获取用户登录信息
    async getUserInfo() {
      const info = await this.$getUserInfo();
      const {
        uid, deviceid, ctoken, utoken, zone,
      } = info;

      this.publicParams = {
        CustomerNo: uid,
        UserId: uid,
        Uid: uid,
        CToken: ctoken,
        UToken: utoken,
        MobileKey: deviceid,
        zone,

        DATES: '',
        POINTCOUNT: '',
        deviceid: '5C1164BA-3D4A-4953-A488-00E47222D4BB' || deviceid,
        plat: 'Iphone',
        AppType: 'Iphone',
        product: 'EFund',
        version: '6.2.5',
        Serverversion: '6.2.5',
        appversion: '6.2.5',
      };
    },
    opengztip() {
      this.isOpenGz = true;
      setStorage('ef-open-fund-valuation', '1');
      this.setOpenV();
      this.setCache('ef-open-fund-valuation', '1');
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp') {
        // eslint-disable-next-line no-undef
        console.log(wx.miniProgram);
        // eslint-disable-next-line no-undef
        if (wx.miniProgram && wx.miniProgram.postMessage) {
          // eslint-disable-next-line no-undef
          wx.miniProgram.postMessage({ data: this.isOpenGz ? '1' : '0' });
        }
      }
      // #endif

      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf2 = multi.$system.webPlatform;
      if (webPlatf2 === 'wap') {
        this.setwebGZOPen();
      }
      // #endif
    },
    setOpenV() {
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      if (fund.setStorageSync) {
      // eslint-disable-next-line no-undef
        fund.setStorageSync({
          key: 'ef-open-fund-valuation',
          data: '1',
          prefix: 0,
          level: 'core',
        });
      }
      // #endif
    },
    // eslint-disable-next-line
    throttlealertGSPCTips:throttle (
      function throttlealertGSPCTips() {
        this.alertGSPCTips();
      },
      1000,
      { trailing: false },
    ),
    alertGSPCTips() {
      let canAlert = false;
      canAlert = false;
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      const systemInfo = fund.getSystemInfoSync();
      if (systemInfo) {
        if (systemInfo.version) {
          if (systemInfo.version >= '6.4.1') {
            // eslint-disable-next-line no-undef
            if (fund.presentPage) {
              canAlert = true;
            }
          }
        }
      }
      // #endif
      // #if EXECUTION_ENV === 'web'
      canAlert = false;
      // #endif
      if (!canAlert) {
        const content = '近30天净值估算与基金实际净值偏离度的平均值。数值越小则表示净值估算越具有参考意义。估值偏差 = avg ( |T日净值估算涨幅-T日实际日涨幅| ) = avg ( |T日净值估算-T日实际净值| / T-1日实际净值 )';
        this.$feedback.showModal({
          title: '净值估算偏差',
          content,
          showCancel: false,
          confirmText: '知道了',
          confirmColor: '#ff4400',
        });
      } else {
        // eslint-disable-next-line no-undef
        fund.presentPage({
          appId: 'f67a50bbe71a4b41a93eb2274e2a95d0',
          url: '/pages/index/valuationinAlert',
          navigationBarDisplay: false,
          animation: false,
        });
      }
      this.reportMonitor({
        eventName: 'pzy.zst.jzgspcsm.click',
      });
    },
    getgzGsClass(name, isOpenGz) {
      if (name === '净值估算') {
        if (!isOpenGz) {
          return 'chart-wrap-no-data-closegz-gs';
        }
      }
      return 'chart-wrap-no-data-closegz-not-gs';
    },
    showyjTips() {

    },
    getShowLJSYzsTipState() {
      const state = Util.getCache('ShowLJSYzsTipState');
      if (state && state === '1') {
        return false;
      }
      return true;
    },
    setShowLJSYzsTipState() {
      Util.setCache('ShowLJSYzsTipState', '1');
    },
    hidLJSYzsTip() {
      if (this.ljsyzsShow) {
        this.setShowLJSYzsTipState();
        this.ljsyzsShow = false;
      }
    },
    // 自动消失
    autoHidLJSYzsTip() {
      setTimeout(() => {
        if (this.ljsyzsShow) {
          this.setShowLJSYzsTipState();
          this.ljsyzsShow = false;
        }
      }, 3000);
    },
    // 后端买卖点
    getShowHDMMDTipState() {
      const state = Util.getCache(`ShowHDMMDTipState-${this.publicParams.Uid}`);
      if (state && state === '1') {
        return false;
      }
      return true;
    },
    setShowHDMMDTipState() {
      Util.setCache(`ShowHDMMDTipState-${this.publicParams.Uid}`, '1');
    },
    hidHDMMDTip() {
      if (this.hdmmdtipshow) {
        this.setShowHDMMDTipState();
        this.hdmmdtipshow = false;
      }
    },
    // 自动消失
    autoHidHDMMDTip() {
      setTimeout(() => {
        if (this.hdmmdtipshow) {
          this.setShowHDMMDTipState();
          this.hdmmdtipshow = false;
        }
      }, 3000);
    },
    isThisYearCreated(createdDate) {
      const date = new Date();
      const nowYear = date.getFullYear();
      if (createdDate && createdDate.indexOf && nowYear) {
        if (createdDate.indexOf(nowYear) !== -1) {
          return true;
        }
      }
      return false;
    },
    needshowHdTip() {
      if (this.getShowHDMMDTipState()) {
        // 判断当前是否有买卖 点
        const hdblsit = this.buyAndSellPointData.hdBuyPoints;
        const hdslsit = this.buyAndSellPointData.hdSellPoints;
        if (hdblsit.length > 0 || hdslsit.length > 0) {
          if (this.typeIndex !== 3) {
            if (!this.hdmmdtipshow) {
              this.hdmmdtipshow = true;
              this.autoHidHDMMDTip();
            }
          }
        }
      }
    },
  },
};
</script>

<style lang="less">
  @import './style.less';
  @import './loading.less';
  /* 设置持续时间和动画函数 */
  .slide-fade-NGuide-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-NGuide-enter
  /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translate(-12px, -26px) scale(0.8);
    opacity: 0.5;
  }
</style>
